/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_ReconnectingInputs */

const th_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเชื่อมต่อใหม่`)
};

const en_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting`)
};

const ja_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再接続中`)
};

const zh_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在重新连接`)
};

const es_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconectando`)
};

const pt_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconectando`)
};

const id_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghubungkan ulang`)
};

const fr_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnexion`)
};

const tl_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muling kumokonekta`)
};

const vi_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kết nối lại`)
};

const ko_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 연결 중`)
};

const de_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung wird wiederhergestellt`)
};

const ru_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переподключение`)
};

const tr_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden bağlanıyor`)
};

const it_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riconnessione`)
};

const pl_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponowne łączenie`)
};

const uk_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перепідключення`)
};

const hi_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से जोड़ा जा रहा है`)
};

const ar_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة الاتصال`)
};

const ms_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyambung semula`)
};

const bn_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আবার যুক্ত হচ্ছে`)
};

const zh_tw2_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新連線中`)
};

const zh_hk2_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新連線中`)
};

const ur_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوبارہ جڑ رہا ہے`)
};

const fa_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال اتصال دوباره`)
};

const sw_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaunganisha upya`)
};

const nl_video_reconnecting = /** @type {(inputs: Video_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw verbinden`)
};

/**
* | output |
* | --- |
* | "Reconnecting" |
*
* @param {Video_ReconnectingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_reconnecting = /** @type {((inputs?: Video_ReconnectingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_ReconnectingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_reconnecting(inputs)
	if (locale === "ja") return ja_video_reconnecting(inputs)
	if (locale === "zh") return zh_video_reconnecting(inputs)
	if (locale === "es") return es_video_reconnecting(inputs)
	if (locale === "pt") return pt_video_reconnecting(inputs)
	if (locale === "id") return id_video_reconnecting(inputs)
	if (locale === "fr") return fr_video_reconnecting(inputs)
	if (locale === "tl") return tl_video_reconnecting(inputs)
	if (locale === "vi") return vi_video_reconnecting(inputs)
	if (locale === "ko") return ko_video_reconnecting(inputs)
	if (locale === "de") return de_video_reconnecting(inputs)
	if (locale === "ru") return ru_video_reconnecting(inputs)
	if (locale === "tr") return tr_video_reconnecting(inputs)
	if (locale === "it") return it_video_reconnecting(inputs)
	if (locale === "pl") return pl_video_reconnecting(inputs)
	if (locale === "uk") return uk_video_reconnecting(inputs)
	if (locale === "hi") return hi_video_reconnecting(inputs)
	if (locale === "ar") return ar_video_reconnecting(inputs)
	if (locale === "ms") return ms_video_reconnecting(inputs)
	if (locale === "bn") return bn_video_reconnecting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_reconnecting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_reconnecting(inputs)
	if (locale === "ur") return ur_video_reconnecting(inputs)
	if (locale === "fa") return fa_video_reconnecting(inputs)
	if (locale === "sw") return sw_video_reconnecting(inputs)
	if (locale === "nl") return nl_video_reconnecting(inputs)
	return en_video_reconnecting(inputs)
});